import React from 'react';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';
var querystring = require('querystring');
import axios from 'axios';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Footer2Component from "../commons/footer2";

export default class SplashHome2Page extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            first_name_lead: '',
            last_name_lead: '',
            email_name_lead: '',
            title_name_lead: '',
            part_name_lead: '',
            subscrible_name_lead: 0,
            errors: {},
            menuShow: false,
        }
    }

    handleChange = (field, event) => {
        let profile = this.state;
        profile[field] = event.target.value;
        this.setState(Object.assign({}, profile));
    }

    handleClickSubscrible = (event) => {
        let profile = this.state;
        profile['subscrible_name_lead'] = this.state.subscrible_name_lead == 1 ? 0 : 1;
        this.setState(Object.assign({}, profile));
    }

    handleClick = (field, part, event) => {
        let profile = this.state;
        let errors = this.state.errors
        profile[field] = part;
        errors['part_name_lead'] = '';
        this.setState(Object.assign({}, profile));
        this.setState({errors: errors});
    }

    handleSubmit = () => {
        let params = this.state;
        let hasErrors = false;
        let errors = {};
        if (params.first_name_lead == '') {
            hasErrors = true;
            errors['first_name_lead'] = 'Required';
        }
        if (params.last_name_lead == '') {
            hasErrors = true;
            errors['last_name_lead'] = 'Required';
        }
        if (params.email_name_lead == '') {
            hasErrors = true;
            errors['email_name_lead'] = 'Required';
        }
        if (params.title_name_lead == '') {
            hasErrors = true;
            errors['title_name_lead'] = 'Required';
        }
        if (params.part_name_lead == '') {
            hasErrors = true;
            errors['part_name_lead'] = 'Required';
        }

        this.setState({errors: errors});

        if (hasErrors == false) {
            axios.post('/code/api_gstarts.php?api=insLead&demo=1', querystring.stringify(params))
                .then(response => {
                    if (response.data.status == 1) {
                        window.location = "/home";
                    }

                    return response;
                });
        }
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        window.location = link;
    }

    render() {
        let part_employer_cls = "border-line"
        let part_student_cls = "border-line"
        let part_other_cls = "border-line other"

        if (this.state.part_name_lead == 1) {
            part_employer_cls = "active border-line"
        }
        else if(this.state.part_name_lead == 2) {
            part_student_cls = "active border-line"
        }
        else if(this.state.part_name_lead == 3) {
            part_other_cls = "active border-line other"
        }

        if (this.state.errors.part_name_lead == 'Required') {
            part_employer_cls = "clss-error border-line"
            part_student_cls = "clss-error border-line"
            part_other_cls = "clss-error border-line other"
        }

		if (isMobile) {
            return (
                <div className="home2_boxx" id="v-splash2_mobile">
                    <div className={"block-001 row mr0"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/home2/m-logo.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                        <div className="col-xs-12 text-center t-content">
                            <h2>The #1 way students<br/> gain experience</h2>
                            <p>Versity connects students with real projects from top organizations</p>

                            <a className="btn" href="/signup">Get Started</a>
                        </div>
                        <img className="img_logo_bg cls-image-line" src={"/static/img/homeimg/home2/img-01-line.png"}/>
                    </div>
                    <div className="row main-content graduate">
                        <div className="graduate-left col-xs-12">
                            <h2 className="title">Students graduate career ready</h2>
                            <div className="s-30">&nbsp;</div>
                            <span className="content">
                                Versity is the first scalable platform designed for students
                                seeking real-world experience through company-endorsed projects.
                                These opportunities allow companies to engage with emerging talent,
                                gaining deeper insights into candidates' profiles, project work,
                                and verified skills using a find-test-acquire approach—moving beyond just resumes.
                            </span>
                        </div>
                        <div className="graduate-right col-xs-12">
                            <img className="img_logo_bg" src={"/static/img/homeimg/home2/img-02-1.png"}/>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                    </div>
                    <div className="row upwork pd0 mg0">
                        <img src={"/static/img/homeimg/home2/m-img-01.png"}/>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content to-do">
                        <span className="top-title">What can Versity do for you?</span>
                        <div className="s-5">&nbsp;</div>
                        <div className="s-40">&nbsp;</div>
                        <div className="div-block-10">
                            <a href="/highered/contact-us" className="user-type-box">I'm a University</a>
                            <div className="_w-30 s-20">&nbsp;</div>
                            <a href="/students" className="user-type-box">I'm a Student</a>
                            <div className="_w-30 s-20">&nbsp;</div>
                            <a href="/companies" className="user-type-box">I'm a Company</a>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                        <div className="div-block-10">
                            <div className="to-do-left col-xs-12 content">
                                <span className="circle"><img src={"/static/img/homeimg/home2/icon-01.png"}/></span>
                                <span className="number">4000+</span>
                                <span className="title">Post-Secondary Institutions</span>
                                <span className="content">
                                    Versity is proud to welcome students and
                                    recent graduates from U.S. based institutions
                                    nationwide.
                                </span>
                            </div>
                            <div className="to-do-middle col-xs-12 content">
                                <span className="circle"><img src={"/static/img/homeimg/home2/icon-02.png"}/></span>
                                <span className="number">45,000+</span>
                                <span className="title">Students & Graduates</span>
                                <span className="content">
                                    Complete company endorsed projects to gain
                                    hands-on experience, demonstrate employable skills
                                    and network with employers.
                                </span>
                            </div>
                            <div className="to-do-right col-xs-12 content">
                                <span className="circle"><img src={"/static/img/homeimg/home2/icon-03.png"}/></span>
                                <span className="number">10,000+</span>
                                <span className="title">Companies & Non-Profits</span>
                                <span className="content">
                                    Match your company needs with students
                                    who can work with you. Build a talent
                                    pipeline of students who are familiar with
                                    your organization.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row main-content book pd0">
                        <div className="book-left col-xs-12 adjust-center">
                            <div className="div-block-8">
                                <div className="div-block-34">
                                    <div className="video w-video w-embed">
                                        <iframe width="560" height="315" src="https://www.youtube.com/embed/7ALV4dg6Nu4"
                                        frameBorder="0"
                                        allowFullScreen></iframe>
                                    </div>
                                </div>
                            </div>
                            <div className="s-60 s-40">&nbsp;</div>
                        </div>
                        <div className="book-right col-xs-12" id="book-a-live">
                            <div className="s-60 s-40">&nbsp;</div>
                            <div className="form-group row">
                                <span className="title">Book a live demo</span>
                            </div>
                            <div className="form-group row">
                                <div className={"col-xs-12 pd0"}>
                                    <label className="t-lab-form">First name<font className={this.state.errors.first_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                    <input
                                        value={this.state.first_name_lead}
                                        onChange={this.handleChange.bind(this, 'first_name_lead')}
                                        type="text"
                                        id="book-a-live-first"
                                        className="form-control"
                                        placeholder={"Your first name"}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className={"col-xs-12 pd0"}>
                                    <label className="t-lab-form">Last name<font className={this.state.errors.last_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                    <input
                                        value={this.state.last_name_lead}
                                        onChange={this.handleChange.bind(this, 'last_name_lead')}
                                        type="text"
                                        className="form-control"
                                        placeholder={"Your last name"}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className={"col-xs-12 pd0"}>
                                    <label className="t-lab-form">Work Email<font className={this.state.errors.email_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                    <input
                                        value={this.state.email_name_lead}
                                        onChange={this.handleChange.bind(this, 'email_name_lead')}
                                        type="text"
                                        className="form-control"
                                        placeholder={"Work Email"}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className={"col-xs-12 pd0"}>
                                    <label className="t-lab-form">Job Title<font className={this.state.errors.title_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                    <input
                                        value={this.state.title_name_lead}
                                        onChange={this.handleChange.bind(this, 'title_name_lead')}
                                        type="text"
                                        className="form-control"
                                        placeholder={"What do you do?"}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className={"col-xs-12 adjust-center pd0"}>
                                    <div className={part_employer_cls} onClick={this.handleClick.bind(this, 'part_name_lead', 1)}>I'm a Company</div>
                                </div>
                                <div className={"col-xs-12 adjust-center pd0"}>
                                    <div className={part_student_cls} onClick={this.handleClick.bind(this, 'part_name_lead', 2)}>I'm a University</div>
                                </div>
                                <div className={"col-xs-12 adjust-center pd0"}>
                                    <div className={part_other_cls} onClick={this.handleClick.bind(this, 'part_name_lead', 3)}>Other</div>
                                </div>
                            </div>
                            <div className="form-group row pd0 mb0">
                                <div className="col-xs-12 pd0 adjust-center">
                                    <input
                                        onClick={this.handleClickSubscrible.bind(this)}
                                        name="subscrible_name_lead"
                                        type="checkbox"
                                        value="1"/>&nbsp;&nbsp;Subscribe to our Newsletter
                                </div>
                                <div className={"col-xs-12 adjust-right pd0"}>
                                    <a className="btn btn-book" onClick={this.handleSubmit.bind(this)}>Book a Demo</a>
                                </div>
                            </div>
                            <div className="s-60 s-40">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper">
                        <div className="logos">
                            <div className="logo logo-4">&nbsp;</div>
                            <div className="logo logo-5">&nbsp;</div>
                            <div className="logo logo-6">&nbsp;</div>
                            <div className="logo logo-7">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper-new">
                        <span className="news-title">Versity in the News</span>
                        <a className="btn btn-press" href="/press-releases">View press</a>
                        <div className="s-30">&nbsp;</div>
                        <div className="logos logos-news">
                            <div className="logo logo-press-1">&nbsp;</div>
                            <div className="logo logo-press-2">&nbsp;</div>
                            <div className="logo logo-press-3">&nbsp;</div>
                            <div className="logo logo-press-4">&nbsp;</div>
                        </div>
                        <div className="s-30">&nbsp;</div>
                        <a href="#book-a-live-first" className="btn btn-news">SUBSCRIBE TO NEWSLETTER</a>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <Footer2Component isSlash={true}/>
                </div>
            )
        }

        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </header>
                <div id="v-splash2" className="splash_wrapper home2_boxx">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div className="t-header">
                                {/*<img className="img_logo_bg cls-image-top" src={"/static/img/homeimg/home2/img-01-top.png"}/>*/}
                                <div className="content">
                                    <h1 className="title">The #1 way students gain experience</h1>
                                    <span className="sub-title">
                                    Versity connects students with real projects<br/>
                                    from top organizations
                                </span>
                                </div>
                            </div>
                            <div className="t-footer">
                                {/*<img className="img_logo_bg" src={"/static/img/homeimg/home2/img-01-button.png"}/>*/}
                                <div className="content">
                                    <a className="btn" href="/signup">Get Started</a>
                                </div>
                            </div>
                        </div>
                        <div className="row main-content graduate">
                            <div className="graduate-left col-xs-6">
                                <h2 className="title">Students graduate career ready</h2>
                                <span className="content">
                                    Versity is the first scalable platform designed for students<br/>
                                    seeking real-world experience through company-endorsed projects.<br/>
                                    These opportunities allow companies to engage with emerging talent,<br/>
                                    gaining deeper insights into candidates' profiles, project work,<br/>
                                    and verified skills using a find-test-acquire approach—moving beyond just resumes.
                                </span>
                            </div>
                            <div className="graduate-right col-xs-6">
                                {/*<img className="img_logo_bg" src={"/static/img/homeimg/home2/img-02-1.png"}/>*/}
                            </div>
                        </div>
                        <div className="row upwork">
                            {/*<img src={"/static/img/homeimg/home2/img-03.png"}/>*/}
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                        <div className="row main-content to-do">
                            <span className="top-title">What can Versity do for you?</span>
                            <div className="s-5">&nbsp;</div>
                            <div className="s-40">&nbsp;</div>
                            <div className="div-block-10">
                                <a href="/highered/contact-us" className="user-type-box">I'm a University</a>
                                <div className="_w-30 s-20">&nbsp;</div>
                                <a href="/students" className="user-type-box">I'm a Student</a>
                                <div className="_w-30 s-20">&nbsp;</div>
                                <a href="/companies" className="user-type-box">I'm a Company</a>
                            </div>
                            <div className="s-60 s-40">&nbsp;</div>
                            <div className="div-block-10">
                                <div className="to-do-left col-xs-4 content">
                                    <div className="circle circle-1">&nbsp;</div>
                                    <span className="number">4000+</span>
                                    <span className="title">Post-Secondary Institutions</span>
                                    <span className="content">
                                        Versity is proud to welcome students and
                                        recent graduates from U.S. based institutions
                                        nationwide.
                                    </span>
                                </div>
                                <div className="to-do-middle col-xs-4 content">
                                    <div className="circle circle-2">&nbsp;</div>
                                    <span className="number">45,000+</span>
                                    <span className="title">Students & Graduates</span>
                                    <span className="content">
                                        Complete company endorsed projects to gain
                                        hands-on experience, demonstrate employable skills
                                        and network with employers.
                                    </span>
                                </div>
                                <div className="to-do-right col-xs-4 content">
                                    <div className="circle circle-3">&nbsp;</div>
                                    <span className="number">10,000+</span>
                                    <span className="title">Companies & Non-Profits</span>
                                    <span className="content">
                                        Match your company needs with students
                                        who can work with you. Build a talent
                                        pipeline of students who are familiar with
                                        your organization.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="s-100 s-40">&nbsp;</div>
                        <div className="row main-content book pd0">
                            <div className="book-left col-xs-7 adjust-center">
                                <div className="div-block-8">
                                    <div className="div-block-34">
                                        <div className="video w-video w-embed">
                                            <iframe width="560" height="315"
                                                    src="https://www.youtube.com/embed/7ALV4dg6Nu4" frameBorder="0"
                                                    allowFullScreen></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="book-right col-xs-5" id="book-a-live">
                                <div className="s-60 s-40">&nbsp;</div>
                                <div className="form-group row">
                                    <span className="title">Book a live demo</span>
                                </div>
                                <div className="form-group row">
                                    <div className={"col-xs-12 pd0"}>
                                        <label className="t-lab-form">First name<font className={this.state.errors.first_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                        <input
                                            value={this.state.first_name_lead}
                                            onChange={this.handleChange.bind(this, 'first_name_lead')}
                                            type="text"
                                            id="book-a-live-first"
                                            className="form-control"
                                            placeholder={"Your first name"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className={"col-xs-12 pd0"}>
                                        <label className="t-lab-form">Last name<font className={this.state.errors.last_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                        <input
                                            value={this.state.last_name_lead}
                                            onChange={this.handleChange.bind(this, 'last_name_lead')}
                                            type="text"
                                            className="form-control"
                                            placeholder={"Your last name"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className={"col-xs-12 pd0"}>
                                        <label className="t-lab-form">Work Email<font className={this.state.errors.email_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                        <input
                                            value={this.state.email_name_lead}
                                            onChange={this.handleChange.bind(this, 'email_name_lead')}
                                            type="text"
                                            className="form-control"
                                            placeholder={"Work Email"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className={"col-xs-12 pd0"}>
                                        <label className="t-lab-form">Job Title<font className={this.state.errors.title_name_lead == 'Required'?"cls-error has-error":"has-error"}>※</font></label>
                                        <input
                                            value={this.state.title_name_lead}
                                            onChange={this.handleChange.bind(this, 'title_name_lead')}
                                            type="text"
                                            className="form-control"
                                            placeholder={"What do you do?"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className={"col-xs-4 adjust-center"}>
                                        <div className={part_employer_cls} onClick={this.handleClick.bind(this, 'part_name_lead', 1)}>I'm an <br/>Company</div>
                                    </div>
                                    <div className={"col-xs-4 adjust-center"}>
                                        <div className={part_student_cls} onClick={this.handleClick.bind(this, 'part_name_lead', 2)}>I'm a <br/>University</div>
                                    </div>
                                    <div className={"col-xs-4 adjust-center"}>
                                        <div className={part_other_cls} onClick={this.handleClick.bind(this, 'part_name_lead', 3)}>Other</div>
                                    </div>
                                </div>
                                <div className="form-group row pd0 mb0">
                                    <div className="col-xs-6 pd0">
                                        <input
                                              onClick={this.handleClickSubscrible.bind(this)}
                                              name="subscrible_name_lead"
                                              type="checkbox"
                                              value="1"/>&nbsp;&nbsp;Subscribe to our Newsletter
                                    </div>
                                    <div className={"col-xs-6 adjust-right pd0"}>
                                        <a className="btn btn-book" onClick={this.handleSubmit.bind(this)}>Book a Demo</a>
                                    </div>
                                </div>
                                <div className="s-60 s-40">&nbsp;</div>
                            </div>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                        <div className="row main-content logos-wrapper">
                            <div className="logos">
                                <div className="logo logo-1">&nbsp;</div>
                                <div className="logo logo-2">&nbsp;</div>
                                <div className="logo logo-3">&nbsp;</div>
                                <div className="logo logo-4">&nbsp;</div>
                                <div className="logo logo-5">&nbsp;</div>
                                <div className="logo logo-6">&nbsp;</div>
                                <div className="logo logo-7">&nbsp;</div>
                            </div>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                        <div className="row main-content logos-wrapper-new">
                            <span className="news-title">Versity in the News</span>
                            <a className="btn btn-press" href="/press-releases">View press</a>
                            <div className="s-30">&nbsp;</div>
                            <div className="logos logos-news">
                                <div className="logo logo-press-1">&nbsp;</div>
                                <div className="logo logo-press-2">&nbsp;</div>
                                <div className="logo logo-press-3">&nbsp;</div>
                                <div className="logo logo-press-4">&nbsp;</div>
                            </div>
                            <div className="s-30">&nbsp;</div>
                            <a href="#book-a-live-first" className="btn btn-news">SUBSCRIBE TO NEWSLETTER</a>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/splash-home2.js
 **/